import { Env } from '@Constants/BuildInfo';
import { getUrlByParam } from '@Services/RequestFactory/RequestFactory';

// eslint-disable-next-line import/prefer-default-export
export const CDDOptions = {
  licenseUrl: `${Env.StructureEditorsHostUrl}/cdn/chemdrawweb/ChemDraw-JS-License.xml`,
  get chemistryServiceURL() {
    return getUrlByParam('', 'ChemDrawServiceUrl');
  },
};
